module.exports = __webpack_public_path__ + "static/media/blocks.0cd5b393.png";